<template>

    <LoopItemPanel title="Kleur selecteren">

        <div class="canvas-blocks-sky-contentCard-LoopItemPanel">

            <ColorsInput
                label="Card kleur"
                instruction="Bepaal hier de achtergrondkleur van de cards."
                :colors="colors"
                :options="loopItem"
                options-property="color"
                @colorChange="save()"
                :open="true"
            />

            <SwitchInput
                label="Toon tekst"
                 instruction="Kies hier om de tekst te tonen onder de titel."
                :items="[
                     { value: 1, label: 'Aan'},
                     { value: 0, label: 'Uit'},
                 ]"
                :options="loopItem"
                options-property="text_switch"
                :defaultValue="1"
                @valueChange="save()"
                :open="true"
            />

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        SwitchInput,
        ColorsInput,
    },

    data: function () {
        return {
            colors: null,
        }
    },

    mounted() {
        this.loadColors();
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await axios.get('/galaxy/crud/' + ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') + 'form/ckeditor/database-colors/data')).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas-blocks-sky-contentCard-LoopItemPanel {


}

</style>
